let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aQKmH")).then(() => parcelRequire('2Zp7K'));